import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./global";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
  Navigate,
} from "react-router-dom";
import {
  CreateRoomScreen,
  GameScreen,
  LobbyRoomScreen,
  LoginScreen,
  RoomListScreen,
} from "./screens";
import { GameProvider } from "./contexts";
import { FirebaseService, theme } from "./utility";
import { RegisterScreen } from "./screens/Register";
import {ForgotScreen } from "./screens/Forgot";
import { AuthProvider, ProtectRoute, useAuth } from "./contexts/auth";
import { AdminScreen } from "./screens/Admin";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'
import styled from "styled-components";

const Navbar = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  padding: 12px 20px;
  z-index: 1000;
`;

const LogoutButton = styled.button`
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: rgba(255, 255, 255, 0.7);
  padding: 6px 14px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  &:hover {
    border-color: white;
    color: white;
  }
`;

function RoomsLayout() {
  const { logout } = useAuth();
  return (
    <>
      <Navbar>
        <LogoutButton onClick={logout}>Logout</LogoutButton>
      </Navbar>
      <Outlet />
    </>
  );
}

FirebaseService.init();

function App() {
  return (
    <ThemeProvider theme={theme}>
       <ToastContainer  />
      <AuthProvider>
        <Router>
          <GameProvider>
            <GlobalStyles />

            <Routes>
              <Route
                path="game/:id"
                element={
                  <ProtectRoute>
                    <GameScreen />
                  </ProtectRoute>
                }
              />
              <Route index element={<Navigate to="/login" replace />} />
              <Route path="login" element={<LoginScreen />} />
              <Route path="register" element={<RegisterScreen />} />
              <Route path="reset" element={<ForgotScreen />} />
              <Route
                path="rooms"
                element={
                  <ProtectRoute>
                    <RoomsLayout />
                  </ProtectRoute>
                }
              >
                <Route index element={<RoomListScreen />} />
                <Route path="create" element={<CreateRoomScreen />} />
                <Route path="lobby/:id" element={<LobbyRoomScreen />} />
              </Route>
              <Route path="admin" element={<AdminScreen />} />
            </Routes>
          </GameProvider>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
